import { PhaserUtils } from "../../utils/PhaserUtils"

export enum SummaryVideo {
    FEW_KIDS_USE = "few-kids-use.mp4",
    SHS = "shs.mp4",
    TOBACCO_IS_ADDICTIVE = "tobacco-is-addictive.mp4",
    TOBACCO_IS_BAD = "tobacco-is-bad.mp4",
    TOBACCO_ISNT_COOL = "tobacco-isnt-cool.mp4",
}

export enum SummaryImage {
    FEW_KIDS_USE = "few-kids-use.jpg",
    SHS = "shs.jpg",
    TOBACCO_IS_ADDICTIVE = "tobacco-is-addictive.jpg",
    TOBACCO_IS_BAD = "tobacco-is-bad.jpg",
    TOBACCO_ISNT_COOL = "tobacco-isnt-cool.jpg",
}

export const loadAssets = (game: Phaser.Game) => {
    const load = PhaserUtils.makeLoader(game, "summary")

    load.autoLoad({videoGenderedEnum: SummaryVideo, imageEnum: SummaryImage})
}

interface Summary {
    video: SummaryVideo
    thumbnail: SummaryImage
    label: string
}

export const summaryData: Array<Summary> = [
    {
        video: SummaryVideo.TOBACCO_IS_BAD,
        thumbnail: SummaryImage.TOBACCO_IS_BAD,
        label: "Tobacco is Bad for You",
    },
    {
        video: SummaryVideo.TOBACCO_IS_ADDICTIVE,
        thumbnail: SummaryImage.TOBACCO_IS_ADDICTIVE,
        label: "Tobacco is Addictive",
    },
    {
        video: SummaryVideo.SHS,
        thumbnail: SummaryImage.SHS,
        label: "Secondhand Smoke",
    },
    {
        video: SummaryVideo.FEW_KIDS_USE,
        thumbnail: SummaryImage.FEW_KIDS_USE,
        label: "Few Kids Use Tobacco",
    },
    {
        video: SummaryVideo.TOBACCO_ISNT_COOL,
        thumbnail: SummaryImage.TOBACCO_ISNT_COOL,
        label: "Tobacco isn't Cool",
    },
]